import { render, staticRenderFns } from "./QuestionChoiceDlg.vue?vue&type=template&id=9331eeac&"
import script from "./QuestionChoiceDlg.vue?vue&type=script&lang=ts&"
export * from "./QuestionChoiceDlg.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionChoiceDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports